<template>
    <div class="affirmation" :data-processing="processing">
       <!-- {{instance}} -->

        <!-- * IF/THEN (ARRAY) -->
        <div v-if="type === 'ifthen'" class="affirmation__response affirmation__response--ifthen v--25">
            <div v-if="selectedResponse.then" 
                class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                :class="selectedResponse.is_correct" 
                v-html="selectedResponse.then"></div>
            <div v-if="selectedResponse.image" class="affirmation__response__image r r--justify-center r--halign-center">
                <PictureDynamic :id="selectedResponse.image" :size="imageSize" alt="Affirmation Image" :siloData="siloData"/>
            </div>
        </div>

        <!-- * EMPTY --> 
        <div v-if="type === 'empty'" class="affirmation__response affirmation__response--empty v--25">
            <div v-if="isEmpty" class="affirmation__response__container affirmation__response__container--empty">
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links" v-html="instance.if"></div>
                <div class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_if" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
            <div v-if="!isEmpty" class="affirmation__response__container affirmation__response__container--not-empty">
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.else"></div>
                <div class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_else" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
        </div>

        <!-- * IF/ELSE -->
        <div v-if="type === 'ifelse'" class="affirmation__response affirmation__response--ifelse v--25">
            <div v-show="isAnswerThis" class="affirmation__response__container affirmation__response__container--is">
                <Kudo v-if="instance.if_correct === 'yes'" :instance="instance" :active="isAnswerThis" />
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.if"></div>
                <div v-if="instance.image_if" class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_if" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
            <div v-show="!isAnswerThis" class="affirmation__response__container affirmation__response__container--is-not">
                <Kudo v-if="instance.else_correct === 'yes'" :instance="instance" :active="!isAnswerThis" />
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.else"></div>
                <div v-if="instance.image_else" class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_else" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import PictureDynamic from "@c/PictureDynamic.vue";
import Picture from "@c/Picture.vue";
import Kudo from "@c/panels/Kudo.vue";
    export default {
        components: {
            PictureDynamic,
            Picture,
            Kudo,
        },
        data() {
            return {
                imageSize: "full",
                processing: this.instance.type !== "empty" ? true : false,
                type: this.instance.type === undefined ? "ifthen" : this.instance.type,
            }
        },
        computed: {
            answer() {
                return this.siloData.user.modules[this.instance.check_field] ? this.siloData.user.modules[this.instance.check_field] : null;
            },
            selectedResponse() {
                if (this.instance.type !== "empty") {
                    this.processing = true;
                }
                
                let returned = {
                    then: "",
                    image: null,
                    is_correct: "",
                };
                // Look through all the responses
                this.instance.responses.forEach(response => {
                    // If your response is your answer
                    if (response.if === this.answer) {
                        // return the then
                        returned.then = response.then;
                        // return the image
                        returned.image = response.image;
                        // return truefalse
                        returned.is_correct = response.is_correct;

                        this.processing = false;
                    }
                });
                return returned;
            },
            isEmpty() {
                return this.answer.length > 0 ? false : true;
            },
            isAnswerThis() {

                // If this is an array, compare it against the first item in the array
                if (Array.isArray(this.answer)) {
                    return this.answer[0] === this.instance.if_equals_text ? true : false;
                // Otherwise, just compare it against the string
                } else {
                    return this.answer === this.instance.if_equals_text ? true : false;
                }
            },
        },
        props: {
            siloData: Object,
            instance: Object,
            active: Boolean,
        },
        watch: {
            siloData: {
                handler() {
                    // This doesn't apply to empty type
                    if (this.instance.type === "empty") return;
                    this.processing = true;
                },
                immediate: true,
            },
        }
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

$icon_incorrect: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs><clipPath id="a"><path d="M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z" /></clipPath><clipPath id="b"><path d="M14.1666667,0 C14.626904,-1.48744461e-15 15,0.373096042 15,0.833333333 C15,1.29357062 14.626904,1.66666667 14.1666667,1.66666667 L0.833333333,1.66666667 C0.373096042,1.66666667 5.63628126e-17,1.29357062 0,0.833333333 C-5.63628126e-17,0.373096042 0.373096042,1.95566521e-16 0.833333333,0 L14.1666667,0 Z" /></clipPath><clipPath id="c"><path d="M14.1666667,0 C14.626904,-4.17611126e-16 15,0.373096042 15,0.833333333 C15,1.29357062 14.626904,1.66666667 14.1666667,1.66666667 L0.833333333,1.66666667 C0.373096042,1.66666667 5.63628126e-17,1.29357062 0,0.833333333 C-5.63628126e-17,0.373096042 0.373096042,8.45442189e-17 0.833333333,0 L14.1666667,0 Z" /></clipPath></defs><g clip-path="url(#a)" transform="rotate(90 15 15)"><polygon fill="#FF4C00" points="0 0 30 0 30 30 0 30 0 0" /></g><g transform="rotate(45 -5.85 16.97)"><g clip-path="url(#b)"><polygon fill="#FFF" points="0 0 15 0 15 1.667 0 1.667 0 0" /></g><path fill="none" stroke="#FFF" stroke-miterlimit="10" d="M0.833333333,0 L14.1666667,0 C14.626904,-1.48744461e-15 15,0.373096042 15,0.833333333 C15,1.29357062 14.626904,1.66666667 14.1666667,1.66666667 L0.833333333,1.66666667 C0.373096042,1.66666667 5.63628126e-17,1.29357062 0,0.833333333 C-5.63628126e-17,0.373096042 0.373096042,1.95566521e-16 0.833333333,0 Z" /></g><g transform="rotate(135 8.316 9.47)"><g clip-path="url(#c)"><polygon fill="#FFF" points="0 0 15 0 15 1.667 0 1.667 0 0" /></g><path fill="none" stroke="#FFF" stroke-miterlimit="10" d="M0.833333333,0 L14.1666667,0 C14.626904,-4.17611126e-16 15,0.373096042 15,0.833333333 C15,1.29357062 14.626904,1.66666667 14.1666667,1.66666667 L0.833333333,1.66666667 C0.373096042,1.66666667 5.63628126e-17,1.29357062 0,0.833333333 C-5.63628126e-17,0.373096042 0.373096042,8.45442189e-17 0.833333333,0 Z" /></g></svg>';
$icon_correct: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs><clipPath id="a"><path d="M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z" /></clipPath><clipPath id="b"><path d="M16.2177793,0.371135209 C16.7126262,0.865982155 16.7126262,1.66828757 16.2177793,2.16313452 L6.1934138,12.1875 L0.371135209,6.36522141 C-0.123711736,5.87037447 -0.123711736,5.06806905 0.371135209,4.5732221 C0.865982155,4.07837516 1.66828757,4.07837516 2.16313452,4.5732221 L6.1934138,8.60350138 L14.42578,0.371135209 C14.9206269,-0.123711736 15.7229323,-0.123711736 16.2177793,0.371135209 Z" /></clipPath><clipPath id="c"><path d="M17.8889145,-1.3 L17.8889145,13.6117641 L-1.3,13.6117641 L-1.3,-1.3 L17.8889145,-1.3 Z M16.2177793,0.371135209 C15.7229323,-0.123711736 14.9206269,-0.123711736 14.42578,0.371135209 L6.1934138,8.60350138 L2.16313452,4.5732221 C1.66828757,4.07837516 0.865982155,4.07837516 0.371135209,4.5732221 C-0.123711736,5.06806905 -0.123711736,5.87037447 0.371135209,6.36522141 L6.1934138,12.1875 L16.2177793,2.16313452 C16.7126262,1.66828757 16.7126262,0.865982155 16.2177793,0.371135209 Z" /></clipPath></defs><g clip-path="url(#a)"><polygon fill="#4CD964" points="0 0 30 0 30 30 0 30 0 0" /></g><g transform="translate(7.161 10.313)"><g clip-path="url(#b)"><polygon fill="#FFF" points="0 0 16.589 0 16.589 12.188 0 12.188 0 0" /></g><g clip-path="url(#c)"><path fill="none" stroke="#FFF" stroke-miterlimit="5" stroke-width=".6" d="M6.1934138,8.60350138 L14.42578,0.371135209 C14.9206269,-0.123711736 15.7229323,-0.123711736 16.2177793,0.371135209 C16.7126262,0.865982155 16.7126262,1.66828757 16.2177793,2.16313452 L6.1934138,12.1875 L0.371135209,6.36522141 C-0.123711736,5.87037447 -0.123711736,5.06806905 0.371135209,4.5732221 C0.865982155,4.07837516 1.66828757,4.07837516 2.16313452,4.5732221 L6.1934138,8.60350138 Z" /></g></g></svg>';
.affirmation {
    [data-processing="true"] {
        .affirmation__response__then {
            opacity: 0;
        }
        .affirmation__response__image {
            opacity: 0;
        }
    }
}
.affirmation__response__then {
    &.answer {
        padding-left: rem(46px);
        &:before {
            content: "";
            display: block;
            width: rem(30px);
            height: rem(30px);
            position: absolute;
            left: 0;
            top: 0;
            background-size: cover;
        }
    }
    &.answer--correct {
        &:before {
            background-image: svg-url($icon_correct);
        }
    }
    &.answer--incorrect {
        &:before {
            background-image: svg-url($icon_incorrect);
        }
    }
}
</style>